// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Redirect = require("../../reason/common/Redirect.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedTeamAccountProfileAboutSettingsQuery_graphql = require("../../__generated__/UnifiedTeamAccountProfileAboutSettingsQuery_graphql.bs.js");
let UnifiedTeamAccountProfileAboutSettingsAboutMutation_graphql = require("../../__generated__/UnifiedTeamAccountProfileAboutSettingsAboutMutation_graphql.bs.js");

let convertVariables = UnifiedTeamAccountProfileAboutSettingsAboutMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedTeamAccountProfileAboutSettingsAboutMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedTeamAccountProfileAboutSettingsAboutMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedTeamAccountProfileAboutSettingsAboutMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedTeamAccountProfileAboutSettingsAboutMutation_graphql.node, convertResponse, convertWrapRawResponse);

let AboutMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useAbout() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedTeamAbout;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

let validators = {
  about: undefined
};

function initialFieldsStatuses(input) {
  return {
    about: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    about: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      about: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, param, param$1) {
  let match = {
    TAG: "Ok",
    _0: input.about
  };
  if (match.TAG === "Ok") {
    return {
      TAG: "Valid",
      output: {
        about: match._0
      },
      fieldsStatuses: {
        about: {
          TAG: "Dirty",
          _0: match,
          _1: "Hidden"
        }
      },
      collectionsStatuses: undefined
    };
  } else {
    return {
      TAG: "Invalid",
      fieldsStatuses: {
        about: {
          TAG: "Dirty",
          _0: match,
          _1: "Hidden"
        }
      },
      collectionsStatuses: undefined
    };
  }
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurAboutField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.about, state.fieldsStatuses.about, status => ({
            about: status
          }));
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateAboutField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.about, status => ({
                about: status
              })),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  about: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  about: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateAbout: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateAboutField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurAbout: () => dispatch("BlurAboutField"),
    aboutResult: Formality.exposeFieldResult(state.fieldsStatuses.about),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.about;
      return typeof tmp === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertVariables$1 = UnifiedTeamAccountProfileAboutSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedTeamAccountProfileAboutSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedTeamAccountProfileAboutSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$1, UnifiedTeamAccountProfileAboutSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, UnifiedTeamAccountProfileAboutSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedTeamAccountProfileAboutSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedTeamAccountProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedTeamAccountProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(UnifiedTeamAccountProfileAboutSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedTeamAccountProfileAboutSettings(props) {
  let match = use$1(undefined, undefined, undefined, undefined);
  let profile = match.currentAccountV5.profile;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/account_profile"
      });
    case "TeamAccountProfile" :
      let match$1 = useAbout();
      let save = match$1[0];
      let form = useForm({
        about: profile.about
      }, (values, param) => {
        let notifyOnFailure = param.notifyOnFailure;
        let notifyOnSuccess = param.notifyOnSuccess;
        save({
          about: Stdlib_Option.getOr(values.about, "")
        }, () => notifyOnSuccess(undefined), param => notifyOnFailure());
      });
      return JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
            title: "About",
            rootName: "Your Team's Profile",
            rootUrl: "/account/account_profile",
            url: "/account/account_profile/about"
          }),
          JsxRuntime.jsxs("form", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                        labelText: "About your team"
                      }),
                      className: "pt-2"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(RichTextEditorV5.make, {
                        initialContent: profile.about,
                        onChange: value => form.updateAbout((_input, value) => ({
                          about: value
                        }), value),
                        onBlur: param => form.blurAbout(),
                        toolbar: "withSingleHeadingLevel",
                        proseStyle: "md"
                      }),
                      className: "mt-2 sm:col-span-2 sm:mt-0"
                    })
                  ],
                  className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
                }),
                className: "pb-12 sm:pb-0"
              }),
              JsxRuntime.jsx(UnifiedProfileSettingsUI.FormActions.make, {
                publicUrl: profile.publicUrl,
                saveDisabled: match$1[1] || form.submitting
              }),
              match$1[2]
            ],
            className: "space-y-6",
            onSubmit: event => {
              event.preventDefault();
              form.submit();
            }
          })
        ],
        className: "space-y-8 rounded bg-white p-6 shadow-sm"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
  }
}

let make = UnifiedTeamAccountProfileAboutSettings;

exports.AboutMutation = AboutMutation;
exports.useAbout = useAbout;
exports.FormConfig = FormConfig;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
